'use client';

import { captureCurrentAttribution } from '@/lib/xAds';
import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';

function XAdsAttributionCaptureInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    captureCurrentAttribution();
  }, [pathname, searchParams]);

  return null;
}

export function XAdsAttributionCapture() {
  return (
    <Suspense fallback={null}>
      <XAdsAttributionCaptureInner />
    </Suspense>
  );
}
